import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the settings state domain
 */

const selectSettingsDomain = state => state.settings || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Settings
 */

const selectSettingsData = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.settingsData,
  );

const selectSettingsList = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.settingsList,
  );

const selectSettingsLoading = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.loading,
  );

const selectSettingsError = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.error,
  );

const selectSettingsDeleteSuccessful = () =>
  createSelector(
    selectSettingsDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectSettingsDomain,
  selectSettingsLoading,
  selectSettingsError,
  selectSettingsDeleteSuccessful,
  selectSettingsData,
  selectSettingsList,
};
